import { JobsList } from '../jobs/JobsList';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { JobsProvider } from '../providers/JobsProvider';


export function JobsPage() {

  return (
    <>
      <JobsProvider />
      <FloatingCardsLayout
        listSize={720}
        list={<JobsList />}
      />
    </>
  );
}
